export default {
  nav: {
    findBarber: 'Trouver un barbier'
  },
  navigation: {
    home: 'Accueil',
    aboutUs: 'À propos',
    contactUs: 'Nous contacter',
    demo: 'Démo',
    login: 'Connexion',
    language: 'Langue',
    logo: 'Logo',
    toggleMenu: 'Ouvrir/Fermer le menu',
    changeLanguage: 'Changer de langue',
    scrollToTop: 'Retour en haut',
    joinAsBarber: 'Rejoindre en tant que barbier',
    pricing: 'Tarifs',
    signUp: 'S\'inscrire'
  },
  home: {
    hero: {
      eyebrow: 'Lancement à Sofia - plus que 3 places disponibles cette semaine',
      mainTitle: 'Votre fauteuil.<br>Votre planning.<br><span class="hero-title-accent">Votre succès.</span>',
      mainDesc: "Vous avez passé des années à perfectionner votre art. Vous ne devriez pas passer vos soirées à répondre sur WhatsApp. Barbers Unity vous offre une page de réservation professionnelle et un agenda complet - pour que vous puissiez vous concentrer sur vos coupes, pas sur la chasse aux clients.",
      growBusiness: 'Je veux plus de clients',
      seeDashboard: 'Voir le tableau de bord',
      trustText: '<strong>Petar Barbov</strong> et de nombreux barbiers à travers l\'Europe utilisent déjà la plateforme.',
      joinThem: 'Rejoignez-les →'
    },
    pain: {
      label: 'Cela vous semble familier ?',
      answer: 'Barbers Unity gère tout ça pour vous.',
      items: [
        'Des clients qui appellent en plein milieu d\'une coupe',
        'Des rendez-vous manqués qui vous font perdre vos meilleurs créneaux',
        'Oublier de confirmer les rendez-vous sur WhatsApp',
        'Des doubles réservations qui nuisent à votre image',
        'Utiliser un agenda papier en 2025'
      ]
    },
    mobile: {
      label: 'Gestion de poche',
      title: 'Gérez votre salon de n\'importe où.',
      desc: "Vous ne travaillez pas derrière un bureau. Barbers Unity est entièrement optimisé pour votre téléphone. Consultez votre agenda, acceptez des rendez-vous et vérifiez l'historique de vos clients entre deux coupes.",
      list: [
        'Notifications instantanées pour les nouveaux rendez-vous',
        'Vue d\'ensemble de l\'historique des clients en un clin d\'œil',
        'Ajout de clients sans rendez-vous à l\'agenda en seulement 3 secondes'
      ]
    },
    featuresList: [
      { title: 'Votre propre page de réservation', desc: 'Un lien professionnel à partager partout - bio Instagram, WhatsApp, Google. Les clients prennent rendez-vous eux-mêmes, 24h/24 et 7j/7.' },
      { title: 'Agenda intelligent', desc: 'Visualisez toute votre semaine en un coup d\'œil. Bloquez vos temps de pause, définissez vos horaires et dites adieu aux doubles réservations.' },
      { title: 'Fichier clients', desc: "L'historique et les coordonnées de chaque client - organisés, faciles à trouver et toujours à portée de main." },
      { title: 'Plateforme internationale', desc: 'Conçue pour les barbiers de toute l\'Europe. Disponible en FR, EN, BG, HR, ALB, GER et d\'autres à venir.' }
    ],
    calendar_preview: {
      title: 'Votre agenda, sur tous vos appareils.'
    },
    how: {
      label: 'Comment démarrer',
      title: 'Prêt à travailler en moins de 10 minutes'
    },
    stepsList: [
      { title: 'Créez votre profil', desc: "Inscrivez-vous en quelques minutes. Ajoutez vos services, définissez vos horaires et obtenez instantanément votre lien de réservation professionnel. Aucune compétence technique n'est requise." },
      { title: 'Partagez votre lien de réservation', desc: 'Ajoutez-le à votre bio Instagram, votre statut WhatsApp ou envoyez-le à vos habitués. Ils prennent rendez-vous en quelques secondes.' },
      { title: 'Venez au salon et coupez', desc: 'L\'agenda se gère tout seul. Vous vous concentrez uniquement sur votre métier et votre réputation.' }
    ],
    trust: {
      card1: { title: 'Nous faisons le gros du travail', desc: "Peur de changer de système ? N'ayez crainte. Envoyez-nous votre fichier clients (Excel, export Booksy, ou des photos de votre vieil agenda) et nous importerons vos clients et créerons votre profil gratuitement." },
      card2: { title: 'Propriété à 100% de vos données', desc: 'Les autres plateformes utilisent vos clients pour mettre en avant des barbiers concurrents. Avec Barbers Unity, votre fichier clients vous appartient à 100 %. Nous ne vendons jamais vos données et n\'envoyons aucune publicité à vos clients.' }
    },
    testimonial: {
      quote: "Avant Barbers Unity, je perdais 3 à 4 rendez-vous par semaine à cause d'appels manqués ou de messages WhatsApp auxquels j'oubliais de répondre. À 20 € la coupe, ça fait 240-320 € de perdus chaque mois. Aujourd'hui, mon agenda se remplit tout seul. Je viens au salon et je coupe.",
      name: 'Petar Barbov',
      role: 'Barbier professionnel · Membre de la première heure'
    },
    stats: {
      label: 'Activité de la plateforme',
      title: 'Des chiffres réels, en croissance chaque jour',
      bookings: 'Rendez-vous gérés',
      clients: 'Clients coiffés',
      time: 'Heures d\'administratif économisées par barbier / semaine'
    },
    pricing: {
      label: 'Tarification juste',
      title: "Ne payez pas de commission sur votre propre succès",
      desc: 'Les autres plateformes vous pénalisent lorsque vous avez plus de clients en vous facturant à la réservation. Nous pensons que ce que vous gagnez vous revient de droit.',
      competitorNote: 'Dès qu\'un barbier concurrent dans votre ville prend sa place, il obtient l\'avantage. Le premier barbier de chaque zone est prioritaire dans les résultats de recherche des clients.',
      identityLine: 'Conçu pour les barbiers qui considèrent leur métier comme un vrai business, pas comme un passe-temps.',
      them: {
        label: 'Les concurrents',
        list: [ 'Facturation à la réservation', 'Frais cachés et coûts imprévus', 'Les coûts augmentent quand vous travaillez plus' ],
        price: "Jusqu'à 200 €",
        sub: '/mois'
      },
      vs: 'VS',
      us: {
        label: 'Barbers Unity',
        list: [ 'Rendez-vous illimités', 'Zéro commission, sans frais cachés', 'Conservez 100 % de vos revenus' ],
        price: '35 €',
        sub: '/mois (prix fixe)'
      }
    },
    calc: {
      label: 'Simulateur de revenus',
      title: "Découvrez combien vous perdez",
      desc: 'Chaque rendez-vous manqué signifie moins d\'argent. Déplacez les curseurs pour voir combien vous pourriez gagner en plus chaque mois.',
      button: 'Commencer à gagner plus',
      cuts: 'Coupes par jour',
      price: 'Prix par coupe (€)',
      missed: 'Rendez-vous manqués par semaine',
      monthlyNow: 'Revenu mensuel actuel',
      withUs: 'Avec Barbers Unity',
      recovered: '/ mois récupérés',
      lossThisMonth: 'déjà perdus ce mois-ci'
    },
    faq: {
      label: 'Vous avez des questions ?',
      title: 'Foire Aux Questions'
    },
    faqList: [
      { q: "Mes clients doivent-ils télécharger une application ?", a: "Non ! Vos clients prennent rendez-vous via un lien simple et rapide, directement depuis leur navigateur. Aucune application à télécharger, aucun compte à créer, aucune prise de tête." },
      { q: "Comment suis-je payé ?", a: "Vous gardez 100 % de ce que vous gagnez. Les clients vous paient directement au salon, comme d'habitude. Nous ne prenons aucun pourcentage ni commission sur votre travail." },
      { q: "Suis-je engagé par un contrat ?", a: "Absolument pas. Barbers Unity fonctionne avec un abonnement mensuel fixe et sans engagement. Vous êtes libre de vous désabonner à tout moment." },
      { q: "J'utilise déjà un autre système. Est-ce difficile d'en changer ?", a: "Cela ne vous demande aucun effort. Envoyez-nous votre fichier clients actuel et nous importerons tout pour créer votre profil, le tout entièrement gratuitement." }
    ],
    upcoming: {
      label: 'Bientôt disponible',
      title: 'Des outils encore plus puissants arrivent',
      badge: 'Bientôt'
    },
    upcomingList: [
      { title: 'Rappels automatiques', desc: 'Des rappels par e-mail et WhatsApp envoyés avant chaque rendez-vous - les "lapins" (rendez-vous non honorés) appartiendront au passé.' },
      { title: 'Analyses et statistiques de revenus', desc: 'Visualisez vos prestations les plus rentables, vos heures de pointe et vos meilleurs clients - prenez de meilleures décisions pour votre salon.' },
      { title: 'Programme de fidélité', desc: 'Récompensez vos clients réguliers, suivez leurs passages au salon et fidélisez-les grâce à notre système intégré.' }
    ],
    cta: {
      eyebrow: 'Places limitées - inscrivez-vous avant qu\'il n\'y en ait plus',
      title: 'Prêt à remplir votre agenda ?',
      sub: 'Rejoignez les barbiers qui gèrent leur propre affaire - et non l\'inverse.',
      microYes: [
        'Je veux un agenda rempli chaque semaine',
        'Je ne veux plus aucun rendez-vous manqué',
        "Je ne veux plus jouer les réceptionnistes"
      ],
      findBarber: 'Trouver un barbier près de chez moi',
      member: 'Déjà membre ?',
      login: 'Connectez-vous à votre tableau de bord →'
    },
    pricingCta: {
      title: 'Prêt à développer votre salon ?',
      subtitle: '35 €/mois · Premier mois gratuit',
      button: 'Commencer'
    }
  },
  about: {
    title: 'À propos de Barbers Unity',
    description: "Nous transformons radicalement la façon dont les barbiers se connectent avec leurs clients. Notre plateforme aide les barbiers à mettre en valeur leur travail, à gérer leurs plannings et à développer efficacement leur activité.",
    founded: 'Fondée en 2025, Barbers Unity est passée d\'une simple idée à une plateforme complète au service des barbiers dans plusieurs pays.',
    ourStory: 'Notre Histoire',
    whatDrivesUs: 'Ce Qui Nous Anime',
    mission: {
      title: 'Notre Mission',
      description: 'Simplifier et moderniser le processus de prise de rendez-vous pour les barbiers.'
    },
    vision: {
      title: 'Notre Vision',
      description: 'Créer la plus grande communauté de barbiers connectés au monde.'
    },
    values: {
      title: 'Nos Valeurs',
      description: 'Qualité, Confiance et Développement Professionnel.'
    },
    built: {
      label: 'Conçu pour le métier',
      title: 'Nous savons ce que c\'est que d\'être derrière le fauteuil.',
      desc1: "Barbers Unity n'a pas été conçu dans des bureaux d'entreprise. Il a été créé parce que nous voyions des barbiers exceptionnels - talentueux, demandés, respectés - perdre des clients à cause d'appels sans réponse et de mauvais systèmes de réservation qui n'étaient pas pensés pour eux.",
      desc2: "Nous avons construit la plateforme que nous aurions aimé avoir : une plateforme qui prend votre métier au sérieux, qui met votre nom en avant, et qui gère l'administratif pour que vous n'ayez pas à vous en soucier.",
      stats: {
        countries: 'Pays dans lesquels nous opérons',
        time: 'Temps de mise en ligne',
        cost: 'Frais d\'installation'
      }
    },
    testimonial: {
      quote: "Avant Barbers Unity, je perdais 3 à 4 rendez-vous par semaine à cause d'appels manqués ou de messages WhatsApp auxquels j'oubliais de répondre. À 20 € la coupe, ça fait 240-320 € de perdus chaque mois. Aujourd'hui, mon agenda se remplit tout seul. Je viens au salon et je coupe.",
      name: 'Petar Barbov',
      role: 'Barbier professionnel · Membre de la première heure'
    },
    timeline: {
      label: 'Chronologie',
      title: 'Construire quelque chose de plus grand.',
      items: [
        { year: '2025', event: 'Création de Barbers Unity - une idée née de la frustration des appels interminables et des rendez-vous manqués.' },
        { year: '2025', event: 'Lancement de la plateforme en version Beta.' },
        { year: 'Aujourd\'hui', event: 'Expansion du réseau - plus de barbiers, plus de villes, de meilleurs outils pour tous.' }
      ]
    },
    cta: {
      eyebrow: 'Places limitées - inscrivez-vous avant qu\'il n\'y en ait plus',
      title: 'Envie de faire partie de l\'histoire ?',
      description: "Que vous soyez barbier ou client, il y a toujours une place pour vous dans la communauté Barbers Unity.",
      findBarber: 'Trouver un Barbier',
      getInTouch: 'Nous Contacter'
    }
  },
  contact: {
    title: 'Nous Contacter',
    getInTouch: {
      title: 'Entrons en contact',
      description: 'Vous avez des questions sur Barbers Unity ? Nous sommes là pour vous aider ! Écrivez-nous sur l\'un de nos réseaux sociaux ou envoyez-nous un message direct.',
      info: "Vous avez des questions sur Barbers Unity ? Nous sommes là pour vous aider - écrivez-nous sur n'importe quel canal ci-dessous."
    },
    followUs: 'Suivez-nous',
    b2b: {
      text: "<strong>Êtes-vous un barbier ?</strong> Sautez le formulaire - réservez un appel gratuit de 20 minutes et nous configurerons tout ensemble.",
      button: 'Réserver un appel gratuit'
    },
    success: {
      title: 'Message envoyé !',
      desc: "Merci de nous avoir contactés. Nous vous répondrons dans les plus brefs délais.",
      button: 'En envoyer un autre'
    },
    form: {
      name: 'Nom',
      namePlaceholder: 'Votre nom',
      email: 'E-mail',
      emailPlaceholder: 'votre@email.com',
      message: 'Message',
      messagePlaceholder: 'Dites-nous comment nous pouvons vous aider...',
      send: 'Envoyer le message'
    }
  },
  forBusiness: {
    hero: {
      eyebrow: 'Places limitées - intégration de nouveaux barbiers en cours',
      mainTitle: 'Arrêtez de gérer votre activité<br><span class="title-accent">à la main.</span>',
      mainDesc: 'Chaque appel manqué est de l\'argent qui vous glisse entre les doigts. Chaque rendez-vous non honoré vous fait perdre un créneau précieux. Barbers Unity vous offre un système professionnel qui garde votre agenda rempli et vos clients informés.',
      bookCall: 'Réserver un appel de configuration gratuit',
      seeDashboard: 'Voir le tableau de bord',
      trust: ['Installation gratuite', 'Sans engagement', 'Prêt à travailler en 10 minutes']
    },
    loss: {
      beforeLabel: 'Sans Barbers Unity',
      afterLabel: 'Avec Barbers Unity',
      without: [
        'Manquer des appels pendant une coupe',
        'Les "lapins" qui laissent des trous dans l\'agenda',
        'Confirmer chaque rendez-vous manuellement',
        'Cahiers brouillons ou fichiers Excel chaotiques',
        'Ne pas savoir quelles prestations rapportent le plus'
      ],
      with: [
        'Les clients prennent RDV en ligne, 24h/24 et 7j/7',
        'L\'agenda se met à jour instantanément, sans effort',
        'Un tableau de bord professionnel, toujours organisé',
        'Historique complet et rapports de prestations',
        'Fonctionne dans plusieurs pays et langues'
      ]
    },
    features: {
      label: 'Ce que vous obtenez',
      heading: 'Tout ce dont un barbier professionnel a besoin',
      items: [
        { title: 'Votre page de réservation professionnelle', desc: 'Un lien épuré à votre nom que vous pouvez partager partout - bio Instagram, WhatsApp, Google. Les clients voient les prestations, les prix, les créneaux libres et prennent rendez-vous eux-mêmes. Fini les appels et les messages sans fin.', badge: 'Prêt en quelques minutes' },
        { title: 'Un agenda complet pensé pour les barbiers', desc: 'Bloquez vos temps de pause, définissez vos horaires de travail, gérez différentes prestations avec des durées variables. Visualisez toute votre semaine d\'un coup d\'œil et ne faites plus jamais de double réservation.', badge: null },
        { title: 'Historique et préférences des clients', desc: "L'historique des coupes, les coordonnées et les notes pour chaque client - tout est organisé. Sachez exactement ce que veut le client avant même qu'il ne s'assoie sur le fauteuil.", badge: null },
        { title: 'Rappels automatiques (bientôt)', desc: 'Des messages de rappel par E-mail et WhatsApp seront envoyés automatiquement avant chaque rendez-vous. Les "lapins" disparaîtront en tant que problème. Lancement très prochainement.', badge: 'Bientôt' }
      ]
    },
    why: {
      label: 'Pourquoi les barbiers nous choisissent',
      heading: 'Votre fauteuil.<br>Vos règles.<br>Vos bénéfices.',
      body: 'Barbers Unity place votre salon devant des clients qui recherchent activement un barbier - sans que vous n\'ayez à les solliciter, leur courir après, ou vous en stresser.',
      list: [
        'Zéro chasse aux clients - ce sont eux qui viennent à vous',
        'Configuration lors d\'un appel de 20 minutes, 100% gratuit',
        'Fonctionne parfaitement avec votre WhatsApp et e-mail actuels',
        "Sans engagement - partez quand vous le souhaitez (mais vous n'en ressentirez pas le besoin)",
        'Un support dédié géré par de vraies personnes, pas des robots'
      ],
      highlights: [
        { title: 'Mise en place instantanée', desc: "Un appel de 20 minutes. Vous êtes prêt à travailler avant même de raccrocher." },
        { title: 'Conçu pour les barbiers', desc: 'Développé en collaboration avec des barbiers - pas seulement pour eux.' },
        { title: 'Multilingue', desc: 'FR, EN, BG, HR, ALB, GER - peu importe où vous travaillez.' },
        { title: 'Sans engagement', desc: 'Commencez gratuitement. Restez parce que ça marche, pas parce que vous y êtes obligé.' }
      ]
    },
    testimonial: {
      quote: "Avant Barbers Unity, je perdais 3 à 4 rendez-vous par semaine à cause d'appels manqués ou de messages WhatsApp auxquels j'oubliais de répondre. À 20 € la coupe, ça fait 240-320 € de perdus chaque mois. Aujourd'hui, mon agenda se remplit tout seul. Je viens au salon et je coupe.",
      name: 'Petar Barbov',
      role: 'Barbier professionnel · Membre de la première heure'
    },
    cta: {
      eyebrow: 'Lancement à Sofia - plus que 3 places disponibles cette semaine',
      mainTitle: 'Prêt à avoir un agenda complet ?',
      sub: "Réservez un appel gratuit de 20 minutes. Nous configurerons tout ensemble - votre profil, vos prestations et votre agenda. Vous serez prêt à travailler avant la fin de l'appel.",
      bookCall: 'Réserver mon appel gratuit maintenant',
      member: 'Déjà membre ?',
      login: 'Connectez-vous à votre tableau de bord →'
    }
  },
  footer: {
    description: 'Connecter les barbiers avec leurs clients, simplifier les réservations et développer les salons.',
    quickLinks: {
      title: 'Liens Rapides',
      about: 'À propos',
      contact: 'Contact',
      demo: 'Démo'
    },
    legal: {
      title: 'Légal',
      privacy: 'Politique de Confidentialité',
      terms: 'Conditions Générales'
    },
    followUs: 'Suivez-nous',
    social: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      tiktok: 'TikTok'
    },
    copyright: '© 2025 BarbersUnity. Tous droits réservés.'
  },
  tailwindMessage: "Tailwind CSS fonctionne avec Vue 3 ! 🎉",
  clickMe: "Cliquez ici",
  previous: 'Retour',
  notFound: {
    title: 'Page Introuvable',
    description: "La page que vous recherchez n'existe pas ou a été déplacée.",
    backHome: 'Retour à l\'accueil'
  },
  cookies: {
    title: 'Paramètres des cookies',
    message: 'Nous utilisons des cookies pour améliorer votre expérience, analyser le trafic du site et fournir un contenu personnalisé. En continuant à utiliser notre site, vous acceptez notre utilisation des cookies.',
    decline: 'Refuser',
    accept: 'Tout Accepter'
  },
  map: {
    eyebrow: 'Trouver un Barbier',
    heading: 'Barbiers près de chez vous',
    searchPlaceholder: 'Rechercher par ville ou nom de barbier...',
    loading: 'Chargement de la carte...',
    error: {
      title: 'Échec du chargement de la carte',
      desc: 'Un problème est survenu lors du chargement de la carte. Veuillez réessayer.',
      retry: 'Réessayer'
    },
    results: 'résultats',
    result: 'résultat',
    bookNow: 'Prendre Rendez-vous'
  },
  privacy: {
    intro: 'Bienvenue sur Barbers Unity. Nous respectons votre vie privée et nous nous engageons à protéger vos données personnelles. Cette politique de confidentialité vous informe sur la manière dont nous traitons vos données lorsque vous visitez notre site, sur vos droits en matière de confidentialité et sur la manière dont la loi vous protège.',
    sections: {
      collect: {
        title: '1. Les informations que nous collectons',
        desc: 'Nous pouvons collecter, utiliser, stocker et transférer différents types de données personnelles vous concernant, que nous avons regroupées comme suit :',
        items: [
          '<strong>Les données d\'identité</strong> comprennent le prénom, le nom de famille, le nom d\'utilisateur ou un identifiant similaire.',
          '<strong>Les données de contact</strong> comprennent l\'adresse e-mail et les numéros de téléphone.',
          '<strong>Les données techniques</strong> comprennent l\'adresse de protocole internet (IP), le type et la version du navigateur, le fuseau horaire et d\'autres technologies sur les appareils que vous utilisez pour accéder à ce site.'
        ]
      },
      use: {
        title: '2. Comment nous utilisons vos données',
        desc: 'Nous n\'utiliserons vos données personnelles que lorsque la loi nous y autorise. Le plus souvent, nous utiliserons vos données dans les circonstances suivantes :',
        items: [
          'Lorsque nous devons exécuter le contrat que nous sommes sur le point de conclure ou que nous avons conclu avec vous (par exemple, la réservation d\'un rendez-vous).',
          'Lorsque cela est nécessaire pour nos intérêts légitimes, et que vos intérêts ou droits fondamentaux ne prévalent pas sur ces intérêts.',
          'Lorsque nous devons nous conformer à une obligation légale.'
        ]
      },
      contact: {
        title: '3. Nous Contacter',
        desc: 'Si vous avez des questions concernant cette politique de confidentialité ou nos pratiques, veuillez nous écrire via nos canaux de contact.'
      }
    }
  },
  pricing: {
    title: 'Tarification simple',
    subtitle: 'Un seul plan. Tout est inclus. Premier mois gratuit.',
    price: '35',
    period: '/mois',
    trial: 'Premier mois GRATUIT',
    cta: 'Démarrer l\'essai gratuit',
    features: [
      'Réservations illimitées',
      'Notifications aux clients',
      'Générateur de QR code & stories',
      'Agenda multi-collaborateurs',
      'Tableau de bord d\'analyses',
      'Support prioritaire'
    ]
  },
  terms: {
    title: 'Conditions Générales',
    intro: 'Bienvenue sur Barbers Unity. En utilisant notre plateforme, vous acceptez ces conditions. Veuillez les lire attentivement.',
    sections: {
      account: {
        title: '1. Inscription au compte',
        desc: 'Vous devez fournir des informations exactes lors de la création d\'un compte. Vous êtes responsable de la sécurité de vos identifiants.'
      },
      usage: {
        title: '2. Utilisation acceptable',
        desc: 'Vous acceptez de ne pas faire un mauvais usage de la plateforme, de ne pas interférer avec son fonctionnement normal et de ne pas tenter d\'y accéder par une méthode autre que l\'interface que nous fournissons.'
      },
      fees: {
        title: '3. Abonnement et frais',
        desc: 'Nos services sont facturés sous forme d\'abonnement. Tous les frais sont non remboursables, sauf si la loi l\'exige.'
      },
      liability: {
        title: '4. Limitation de responsabilité',
        desc: 'Barbers Unity est fourni "tel quel". Nous ne serons pas responsables des dommages indirects, accessoires ou consécutifs découlant de votre utilisation de la plateforme.'
      }
    }
  },
  loading: {
    title: 'Chargement...',
    message: 'Veuillez patienter'
  },
  modal: {
    registerTitle: 'Choisissez le type de compte',
    businessTitle: 'S\'inscrire en tant qu\'entreprise',
    businessDesc: 'Salon / Barbier',
    customerTitle: 'S\'inscrire en tant que client',
    customerDesc: 'Prendre rendez-vous'
  }
}